import { StandaloneShowsSlider } from '@/components/content/ShowsSlider';
import { LabradorComponent } from '@/types/component';
import { useMemo } from 'react';

const FeminaDefaultShowsSlider: LabradorComponent = ({ type, meta, data, descendants }) => {
  const showsItems = useMemo(() => descendants.map((descendant) => ({ ...descendant.data, title: undefined })), []);

  const options = useMemo(
    () => ({
      $swiper: {
        $content: {
          size: 'none',
        },
        spaceBetween: 12,
      },
    }),
    []
  );
  return <StandaloneShowsSlider shows={showsItems} options={options} />;
};

export const standalone = StandaloneShowsSlider;

export default FeminaDefaultShowsSlider;
